import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactPortal } from "react"
import { IOWidget, Options, Fun, Option, mk_widget, Widget } from "../widget";

export interface ModalProps<i,o> {
  modal_root:HTMLElement
  input:i
  inner_widget:IOWidget<i,o>
  on_done:(output:o) => void
}
export interface ModalState<i,o> {
}
export class Modal<i,o> extends React.Component<ModalProps<i,o>, ModalState<i,o>> {
  constructor(props:ModalProps<i,o>, context:any) {
    super(props, context)

    this.state = { value:props.input }
    this.el = document.createElement('div');
  }

  el:HTMLDivElement
  componentDidMount() {
    this.props.modal_root.appendChild(this.el);
  }

  componentWillUnmount() {
    this.props.modal_root.removeChild(this.el);
  }

  render(): React.ReactNode {
    return ReactDOM.createPortal(
      this.props.inner_widget(this.props.input).run(o => this.props.on_done(o)),
      this.el,
    )
  }
}

export let modal_io = function<i,o>(modal_root_id:string) : (_:IOWidget<i,o>) => IOWidget<i,o> {
  const modal_root = document.getElementById(modal_root_id)!

  return inner_widget => (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<ModalProps<i,o>>(Modal, { on_done, inner_widget, input, modal_root:modal_root })
  })
}

export let modal = function<o>(modal_root_id:string) : (widget:Widget<o>) => Widget<o> {
  return widget => modal_io<{},o>(modal_root_id)(_ => widget)({})
}
